import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";

/** API */
import { updatePassword } from "../../../services/api";
import { passEncrypt } from "../../../services/libService";

/** Components */
import { Button, TextField } from "@material-ui/core";
import { useSnackbar } from "notistack";

export default function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { userid } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const handleSubmit = () => {
    updatePassword(userid, {
      current_password: passEncrypt(currentPassword),
      password: passEncrypt(newPassword),
      password_confirmation: passEncrypt(confirmPassword),
    }).then((res) => {
      enqueueSnackbar(res.message, { variant: res.code === 200 ? "success" : "" });
      if (res.code === 200) {
        history.push("/");
      }
    });
  };
  return (
    <div>
      <h4>Change password</h4>
      <TextField label="Current password" fullWidth type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} style={{ margin: 10 }} />
      <TextField label="New password" fullWidth type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={{ margin: 10 }} />
      <TextField label="Confirm new password" fullWidth type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} style={{ margin: 10 }} />
      <Button color="secondary" variant="contained" style={{ margin: 5 }} onClick={() => history.push("/")}>
        Back
      </Button>
      <Button color="primary" variant="contained" style={{ margin: 5 }} onClick={handleSubmit}>
        Save
      </Button>
    </div>
  );
}
